import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { DashboardRoutingModule } from './dashboard-routing.module';
import SharedModule from '../../shared/shared.module';

@NgModule({
    imports: [DashboardRoutingModule, CommonModule, SharedModule, ReactiveFormsModule],
})
export class DashboardModule {}
